import WizardSteps from './wizardSteps';

export default WizardSteps;
